import React from "react";
import { BaseAlert } from "../base/BaseAlert";
import { AlertType } from "@/utils/alert-styles";

export interface ReviewFieldWrapperProps {
  label: string;
  value: string | null;
  showAlert?: boolean;
  alertType?: AlertType;
  alertTitle?: string;
  alertMessage?: string;
  children?: React.ReactNode;
  className?: string;
  "data-testid"?: string;
}

export const ReviewFieldWrapper: React.FC<ReviewFieldWrapperProps> = ({
  label,
  value,
  showAlert = false,
  alertType = "info",
  alertTitle = "",
  alertMessage = "",
  children,
  className = "",
  "data-testid": testId,
}) => {
  const fieldContent = children || (
    <div>
      <span className="text-gray-600 text-sm">{label}</span>
      <p className="font-medium text-gray-900">{value || "Não informado"}</p>
    </div>
  );

  if (!showAlert) {
    return (
      <div className={className} data-testid={testId}>
        {fieldContent}
      </div>
    );
  }

  const borderColors = {
    loading: "border-[#EBE4D8]",
    success: "border-[#99C2AC]",
    error: "border-[#C54444]",
    warning: "border-orange-200",
    info: "border-[#EBE4D8]",
    infoBlue: "border-[#9CADD9]",
  };

  return (
    <div
      className={`border ${borderColors[alertType]} rounded-[16px] p-4 bg-white ${className}`}
      data-testid={testId}
    >
      {fieldContent}
      {showAlert && (
        <div className="mt-3">
          <BaseAlert
            type={alertType}
            title={alertTitle}
            message={alertMessage}
            size="compact"
          />
        </div>
      )}
    </div>
  );
};

ReviewFieldWrapper.displayName = "ReviewFieldWrapper";
